import { BusinessNameContactDataForm, BusinessNameContactFilters } from '../../../../app/models/BusinessNameContact';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import BusinessNameContactSwitchChange from '../BusinessNameContactSwitchChange';

interface Props {
    contacts: BusinessNameContactDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: BusinessNameContactFilters;
    setFilter: (filter: BusinessNameContactFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    notActions?: boolean;
}

const BusinessNameContactDataTable = ({
    contacts,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess,
    notActions=true
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => <span className="">{row.name}</span>
        },

        {
            name: 'Correo',
            selector: (row: any) => row.email,
            sortable: true,
            sortField: 'email',
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => <span className="">{row.email}</span>
        },
        {
            name: 'Tipo de contacto',
            selector: (row: any) => row.contact_type,
            sortable: true,
            sortField: 'contact_type',
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => <span className="">{row.contact_type}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => (
                notActions
                ? row.is_active ? 'Sí' : 'No'
                : (
                  <BusinessNameContactSwitchChange
                      checkValue={row.is_active ?? true}
                      businessNameContactId={row.id!}
                      callbackSuccess={callbackSuccess!}
                  />
                )
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            omit: notActions,
            cell: (row: BusinessNameContactDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* <BankFilters filter={filter} setFilter={setFilter} /> */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={contacts}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default BusinessNameContactDataTable;
